// extracted by mini-css-extract-plugin
export default {"Container":"SelfServiceTemplate_Container__21yE0","PageContent":"SelfServiceTemplate_PageContent__xmMmg","TemplateNavBar":"SelfServiceTemplate_TemplateNavBar__4IH8H"};